import { Checkbox } from "@tvg/design-system";
import React from "react";
import { RaceProgram } from "@tvg/ts-types/Race";

const PicksSelectorCheck = (props: {
  columnNumber: number | null;
  lineNumber: number | null;
  hasAllRaces: boolean;
  biNumber?: string;
  selectedValues?: string[] | [];
  onSelectRunner?: (
    biNumber: string,
    line: number,
    column: number,
    isSelected: boolean
  ) => void;
  race?: RaceProgram;
  onSelectAll?: (
    column: number,
    isSelected: boolean,
    race: RaceProgram
  ) => void;
}) => (
  <Checkbox.Group
    mb="space-0"
    selectedValues={props.selectedValues}
    onChange={() => {
      if (
        props.onSelectRunner &&
        props.biNumber &&
        props.columnNumber !== null &&
        props.lineNumber !== null
      ) {
        props.onSelectRunner(
          props.biNumber,
          props.lineNumber,
          props.columnNumber,
          !(
            props.selectedValues !== undefined &&
            props.selectedValues.length > 0
          )
        );
      }
      if (props.onSelectAll && props.race && props.columnNumber !== null) {
        props.onSelectAll(
          props.columnNumber,
          !(
            props.selectedValues !== undefined &&
            props.selectedValues[0] === "all"
          ),
          props.race
        );
      }
    }}
    qaLabel={`checkbox-group-column-${props.columnNumber}`}
    isDisabled={!props.hasAllRaces}
  >
    <Checkbox
      qaLabel={`checkbox-column-${
        props.columnNumber !== null ? props.columnNumber : "N/A"
      }-line-${props.lineNumber !== null ? props.lineNumber + 1 : "N/A"}`}
      m="space-2"
      value={props.onSelectAll ? "all" : props.biNumber || ""}
      label=""
    />
  </Checkbox.Group>
);

export default PicksSelectorCheck;
